import React from "react";
const Facebook = ({width = "48", height= '48'}) =>{
    return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 36 36" fill="none">
        <g clipPath="url(#clip0_402_10912)">
            <path d="M15.307 35.3056C7.04308 33.8472 0.723633 26.6528 0.723633 18C0.723633 8.375 8.59863 0.5 18.2236 0.5C27.8486 0.5 35.7236 8.375 35.7236 18C35.7236 26.6528 29.4042 33.8472 21.1403 35.3056L20.1681 34.5278H16.2792L15.307 35.3056Z" fill="url(#paint0_linear_402_10912)"/>
            <path d="M25.0318 22.8617L25.8096 18.0006H21.1429V14.5978C21.1429 13.2367 21.629 12.1673 23.7679 12.1673H26.004V7.69504C24.7401 7.5006 23.379 7.30615 22.1151 7.30615C18.129 7.30615 15.3096 9.73671 15.3096 14.1117V18.0006H10.9346V22.8617H15.3096V35.2089C16.2818 35.4034 17.254 35.5006 18.2262 35.5006C19.1985 35.5006 20.1707 35.4034 21.1429 35.2089V22.8617H25.0318Z" fill="white"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear_402_10912" x1="18.2236" y1="34.2886" x2="18.2236" y2="0.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#0062E0"/>
                <stop offset="1" stopColor="#19AFFF"/>
            </linearGradient>
            <clipPath id="clip0_402_10912">
                <rect width="35" height="35" fill="white" transform="translate(0.723633 0.5)"/>
            </clipPath>
        </defs>
    </svg>
}

export default Facebook;